<template>
  <div>
    <el-button @click="beforeOpenDialog" class="select-project-action" :disabled="disabled">
      <el-tag
        effect="dark"
        v-show="!projectShowList.length"
        :disable-transitions="true"
        class="no-select-tag"
      >{{ noSelectShowText }}</el-tag>
      <transition-group name="tag-in-input">
        <el-tag
          v-show="projectShowList.length"
          v-for="(item, index) in projectShowList"
          :type="item.type ? 'success' : ''"
          :key="item.id + 'tags'"
          @click="beforeOpenDialog"
          effect="dark"
          style="margin: 0 5px;"
          disable-transitions
        >
          <i
            :class="item.type ? 'el-icon-user-solid' : 'el-icon-folder-opened'"
            style="display:inline-block;"
          ></i>
          <span class="select-employees-tagText">{{ item.name }}</span>
        </el-tag>
      </transition-group>
      <el-tag
        v-show="moreItemNum"
        @click="beforeOpenDialog"
        effect="dark"
        style="margin: 0 5px;"
        disable-transitions
      >
        <i class="el-icon-circle-plus-outline"></i>
        <span>{{ moreItemNum }}</span>
      </el-tag>
    </el-button>

    <el-dialog
      title="选择项目"
      :visible.sync="dialogVisible"
      width="720px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="dialog-select">
        <el-card class="dialog-left-select" v-loadmore="loadmoreConfig" shadow="hover">
          <p class="select-title">选择：</p>

          <!-- 部门层级 -->
          <Breadcrumb separator=">">
            <BreadcrumbItem
              v-for="(item, index) in directoryLevels"
              :key="item.id + 'breadcrumb'"
              @click.native="handleClickDirectory(item, index)"
            >{{ item.name }}</BreadcrumbItem>
          </Breadcrumb>

          <el-checkbox-group v-model="currentSelected">
            <el-scrollbar class="left-scroll-wrapper">
              <div
                v-for="item in currentProjectListStringify"
                :key="item"
                style="display: flex;align-items: center;"
              >
                <el-checkbox
                  :label="item"
                  :key="JSON.parse(item).id"
                  class="select-item"
                >
                <span
                  class="select-item-name"
                  :title="JSON.parse(item).name"
                >{{ JSON.parse(item).name }}</span>

                </el-checkbox>
                <div v-if="hasChildren(JSON.parse(item))" style="width: 80px">
                  <el-link
                    class="select-item-next"
                    :underline="false"
                    @click="intoNextDirectory(item)"
                  >
                    <i class="el-icon-paperclip" />
                    下级
                  </el-link>
                </div>
              </div>>
            </el-scrollbar>
          </el-checkbox-group>
        </el-card>

        <el-card class="dialog-right-select" shadow="hover">
          <p class="select-title">已选：</p>

          <el-scrollbar class="right-scroll-wrapper">
            <li v-for="(item, index) in currentSelected" :key="item" class="select-item">
              <span
                class="select-item-name"
                :title="JSON.parse(item).name"
              >{{ JSON.parse(item).name }}</span>
              <i class="el-icon-delete-solid select-item-icon" @click="removeProject(index)" />
            </li>
          </el-scrollbar>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const loadSize = 10;
const projectEnumId = "10001";

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    noSelectShowText: {
      type: String,
      default: "请选择项目"
    },

    //展示的个数限制
    maxShowItem: {
      type: Number,
      default: 2
    },

    defaultSelected: {
      type: Array,
      default: _ => []
    }
  },

  data() {
    return {
      dialogVisible: false,

      // 当前目录id
      currentDirectoryId: "",
      currentProjectList: [],

      // 当前目录选择的
      currentSelected: [],

      confirmSelected: [],

      // 所有目录选择的
      // allDirectorySelected: [],

      directoryLevels: [],

      pageConfig: { current: 1, pages: 1 },

      loadmoreConfig: {
        loadmore: this.loadMoreProject,
        className: "el-scrollbar__wrap"
      }
    };
  },

  computed: {
    getProjectListApi() {
      const apiName =
        this.currentDirectoryId === projectEnumId
          ? "getAssistSuperclasses"
          : "getAssistSubclasses";
      return this.$api[apiName];
    },

    currentProjectListStringify() {
      return this.stringifyProjectList(this.currentProjectList);
    },

    moreItemNum() {
      const moreItemNum = this.confirmSelected.length - this.maxShowItem;

      return moreItemNum > 0 ? moreItemNum : 0;
    },

    projectShowList() {
      const confirmSelectedObj = this.confirmSelected.map(item =>
        JSON.parse(item)
      );

      return this.moreItemNum
        ? confirmSelectedObj.slice(0, this.maxShowItem)
        : confirmSelectedObj;
    },

    selectedProject() {
      return this.confirmSelected.map(item => JSON.parse(item));
    },

    currentSelectedIds() {
      return this.currentSelected.map(item => JSON.parse(item).id);
    }
  },

  watch: {
    currentDirectoryId: {
      handler(newValue) {
        this.currentProjectList = [];
        this.initPageConfig();
        this.setProjectList(newValue);
      }
    },

    defaultSelected: {
      deep: true,
      handler(newValue) {
        this.confirmSelected = this.stringifyProjectList(newValue);
      }
    }
  },

  methods: {
    beforeOpenDialog() {
      if (this.disabled) return;

      // 首次弹窗加载初始化的数据
      if (!this.currentDirectoryId) {
        this.initCurrentDirectoryId();
      }

      this.openSelectDialog();
    },

    initCurrentDirectoryId() {
      this.currentDirectoryId = projectEnumId;
      this.directoryLevels = [
        {
          name: "项目",
          id: projectEnumId
        }
      ];
    },

    openSelectDialog() {
      this.currentSelected = this.$js.deepClone(this.confirmSelected);
      this.dialogVisible = true;
    },

    initPageConfig() {
      this.pageConfig = { current: 1, pages: 1 };
    },

    stringifyProjectList(projectList) {
      const list = projectList.map(item => {
        return JSON.stringify({
          id: item.id,
          name: item.name
        });
      });
      return list;
    },

    async setProjectList(parentId) {
      const id = this.currentDirectoryId || projectEnumId;
      const pageParams = {
        from: this.pageConfig.current,
        size: loadSize,
        assistId: projectEnumId
      };
      const { pages, records } = await this.getProjectListApi(pageParams, id);

      this.currentProjectList.push(...records);
      this.pageConfig.pages = pages;
    },

    loadMoreProject() {
      if (this.pageConfig.current >= this.pageConfig.pages) return;

      this.pageConfig.current++;
      this.setProjectList(this.currentDirectoryId);
    },

    intoNextDirectory(projectStr) {
      this.currentDirectoryId = JSON.parse(projectStr).id;
      const project = JSON.parse(projectStr);
      this.directoryLevels.push({ id: project.id, name: project.name });
    },

    handleClickDirectory(item, index) {
      //将点击的导航条之后的数据删除
      this.directoryLevels = this.directoryLevels.slice(0, index + 1);
      //之后，将根据组织id刷新数据
      this.currentDirectoryId = item.id;
    },

    removeProject(index) {
      this.currentSelected.splice(index, 1);
    },

    cancel() {
      this.dialogVisible = false;
    },

    confirm() {
      this.confirmSelected = this.$js.deepClone(this.currentSelected);
      this.dialogVisible = false;
    },

    hasChildren(project) {
      return this.currentProjectList.find(p => p.id === project.id).hasChildren;
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  background-color: rgb(236, 239, 244);
  border-radius: 0 0 10px 10px;

  .el-dialog__title {
    font-size: 20px;
  }
}

.select-title {
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  text-align: left;
  margin: 20px;
}

.dialog-select {
  height: 400px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .dialog-left-select,
  .dialog-right-select {
    width: 320px;
    height: 100%;
    overflow: hidden;
    background-color: rgb(236, 239, 244);
  }

  // 滚动条
  ::v-deep .el-card__body {
    padding: 0;
  }

  .left-scroll-wrapper {
    height: 280px;
  }

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}

.select-item {
  width: 100%;
  height: 40px;
  padding: 0 20px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ::v-deep .el-checkbox__input {
    padding: 3px 0 0 0;
  }

  ::v-deep .el-checkbox__label {
    flex: 1;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 20px;

    .select-item-name {
      flex: 1;
      height: 100%;
      line-height: 40px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .select-item-next {
      width: 50px;
      font-size: 12px;
      height: 100%;
      line-height: 40px;
    }
  }
}

.dialog-right-select {
  .select-item-icon {
    color: #fb6370;
    font-size: 18px;
    margin: 2px 5px 5px 10px;
    cursor: pointer;
  }

  .select-item-name {
    padding: 0 0 0 10px;
  }

  .right-scroll-wrapper {
    height: 330px;
  }
}

/* 导航条样式 */
::v-deep .ivu-breadcrumb {
  margin: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl;
  text-align: left;

  ::v-deep .ivu-breadcrumb-item-separator {
    color: #464c5b;
  }

  & > span:last-child .ivu-breadcrumb-item-link {
    color: #464c5b;
    cursor: text;
  }
}

// 展示样式
.select-project-action {
  .no-select-tag {
    background: none !important;
    border: none !important;
    color: #464c5b !important;
  }
}
</style>
